import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

/* tslint:disable-next-line:no-any */
export var authFactory = function authFactory(authFn) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cb) {
      var _token;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return authFn();

            case 3:
              _token = _context.sent;
              cb(_token);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              cb('', _context.t0.message);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90YWcvYXV0aEZhY3RvcnkudHMiXSwibmFtZXMiOlsiYXV0aEZhY3RvcnkiLCJhdXRoRm4iLCJjYiIsInRva2VuIiwibWVzc2FnZSJdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7QUFLQSxPQUFPLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjLENBQUNDLE1BQUQ7QUFBQTtBQUFBLHdFQUFtQyxpQkFBT0MsRUFBUDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLHFCQUV0Q0QsTUFBTSxFQUZnQzs7QUFBQTtBQUVwREUsY0FBQUEsTUFGb0Q7QUFHMURELGNBQUFBLEVBQUUsQ0FBQ0MsTUFBRCxDQUFGO0FBSDBEO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBSzFERCxjQUFBQSxFQUFFLENBQUMsRUFBRCxFQUFLLFlBQUlFLE9BQVQsQ0FBRjs7QUFMMEQ7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0FBbkM7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxDQUFwQiIsInNvdXJjZXNDb250ZW50IjpbIi8qIHRzbGludDpkaXNhYmxlLW5leHQtbGluZTpuby1hbnkgKi9cbmV4cG9ydCB0eXBlIEVycm9yUmVhc29uID0gYW55O1xuXG5leHBvcnQgdHlwZSBBdXRoQ2FsbGJhY2sgPSAodG9rZW46IHN0cmluZywgZXJyb3JSZWFzb24/OiBFcnJvclJlYXNvbikgPT4gdm9pZDtcblxuZXhwb3J0IGNvbnN0IGF1dGhGYWN0b3J5ID0gKGF1dGhGbjogKCkgPT4gUHJvbWlzZTxzdHJpbmc+KSA9PiBhc3luYyAoY2I6IEF1dGhDYWxsYmFjaykgPT4ge1xuICB0cnkge1xuICAgIGNvbnN0IHRva2VuID0gYXdhaXQgYXV0aEZuKCk7XG4gICAgY2IodG9rZW4pO1xuICB9IGNhdGNoIChlcnIpIHtcbiAgICBjYignJywgZXJyLm1lc3NhZ2UpO1xuICB9XG59O1xuIl19